import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

const SCHEMA = Object.freeze({
  EMAIL: '',
  NAME: '',
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class CompanyInfo extends Record(RECORD) {
  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }
}
